import { useContext } from 'react';
// НЕ из '.' (entry): импорт entry ломал HMR — см. src/storeContext.tsx
import { StoreContext } from './storeContext';
import type { ConfigStoreType } from '@store/ConfigStore';
import type { XStoreT } from '@store/XStore';
import type { UserStoreType } from '@store/UserStore';
import type { CartStoreType } from '@store/CartStore';
import type { ModalsStoreType } from '@store/ModalsStore';
import type { CatalogStoreType } from '@store/CatalogStore';
import type { UtilsStoreType } from '@store/UtilsStore';
import type { BarMenuStoreT } from '@store/BarMenuStore';
import type { SeoStoreType } from '@store/SeoStore';

export const useStores = (): {
  appStore: any;
  configStore: ConfigStoreType;
  xStore: XStoreT;
  userStore: UserStoreType;
  cartStore: CartStoreType;
  modalsStore: ModalsStoreType;
  catalogStore: CatalogStoreType;
  utilsStore: UtilsStoreType;
  barMenuStore: BarMenuStoreT;
  seoStore: SeoStoreType;
} => {
  const store = useContext(StoreContext);
  if (!store) throw new Error('StoreProvider missing');
  return store;
};
